import {
    LOAD_SHIFTS,
    SHIFTS_FAILURE,
    SHIFTS_SUCCESS,
    SHIFTS_SELECTED,
    CANCEL_SHIFTS,
    CANCEL_SHIFTS_SUCCESS,
    CANCEL_SHIFTS_FAILURE,
    SET_SELECTED_JOBS,
} from '../actions';
import { UPDATE_BOOKING_FIELD } from '../actions/Bookings';

const initialState = {
    fetching: false,
    error: undefined,
    content: [],
    selections: {
        fetching: false,
        error: undefined,
        selected: undefined,
    },
    create: undefined,
    edit: undefined,
    duplicate: undefined,
    meta: {
        count: 0,
        previous: null,
        next: null,
        status_code: undefined,
    },
    selectedJobs: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_SHIFTS:
            return {
                ...state,
                error: undefined,
                fetching: true,
            };
        case SHIFTS_FAILURE:
            return {
                ...state,
                error: action.payload,
                fetching: false,
                meta: action.payload.meta,
            };
        case SHIFTS_SUCCESS:
            return {
                ...state,
                fetching: false,
                error: undefined,
                content: action.payload.content,
                meta: action.payload.meta,
            };
        case SHIFTS_SELECTED:
            return {
                ...state,
                selections: {
                    error: undefined,
                    fetching: false,
                    selected: action.payload,
                },
            };
        case CANCEL_SHIFTS:
            return {
                ...state,
                selections: {
                    error: undefined,
                    fetching: true,
                },
            };
        case CANCEL_SHIFTS_FAILURE:
            return {
                ...state,
                selections: {
                    error: action.payload,
                    fetching: false,
                },
            };
        case CANCEL_SHIFTS_SUCCESS:
            return {
                ...state,
                selections: {
                    error: undefined,
                    fetching: false,
                },
            };
        case UPDATE_BOOKING_FIELD:
            return {
                ...state,
                content: state.content.map(job =>
                    job.id === action.payload.jobId &&
                    job.booking &&
                    job.booking.id === action.payload.id
                        ? {
                              ...job,
                              booking: {
                                  ...job.booking,
                                  ...action.payload.data,
                              },
                          }
                        : job,
                ),
            };
        case SET_SELECTED_JOBS:
            return {
                ...state,
                selectedJobs: action.payload,
            };
        default:
            return state;
    }
};

export default reducer;
